import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareGoalsClassicRoute: InvariantJiraRoute = {
	name: 'software-goals-classic',
	path: '/jira/software/c/projects/:projectKey/goals',
};
